module.exports = __webpack_public_path__ + "static/media/diaper.79f99e66.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Diaper/diaper.svg
// module id = 401
// module chunks = 0